export enum AccountCommunicationTypeOption {
    PROCESS = '8e6549bd-5b3a-495e-b6ec-6f1cd6d87ac2',
    CHAT = '4c0e04fd-02ad-4f12-95da-9ff9fd245f93',
}
